@use '~/theme/theme' as *;
@use '~/theme/typography';

.modal {
  height: 90vh;
  width: 640px;
}

.content {
  gap: spacing(3);
  overflow: hidden;
}

.list {
  overflow: auto;
}

.counterpartCardRadio {
  @include border-radius(sm);

  padding: spacing(2);
  flex-direction: row;
  align-items: start !important;
  gap: spacing(2) !important;
  transition:
    250ms border-color,
    250ms background-color;
  box-shadow: none;
  border: border(grey-400);
  height: 100%;

  &:hover {
    background-color: color(grey-100);
  }

  &[data-selected='true'] {
    border-color: color(violet-500);
    background-color: color(violet-100);
  }
}

.counterpartRow {
  @include border-radius(sm);

  padding: spacing(1);
  transition: 250ms background-color;

  &[data-selected='true'] {
    background-color: color(violet-100);
  }
}

.counterpartCardChip {
  margin-top: spacing(1);
}

.mainCounterpartRow {
  @include border-radius(sm);

  padding: spacing(1.5);
  background-color: color(violet-100);
}

.counterpartCardsRow {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: spacing(2);
  grid-row: 1;
}
